// Angular
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// Object-Path
import * as objectPath from 'object-path';
// Layout
import { LayoutConfigService, SplashScreenService } from '../../../../core/_base/layout';
import { SystemSettingService } from '@app/api/systemsettting.service';
import { SystemSettingStore } from '@app/services/change-setting.service';
import { environment } from 'environments/environment';
@Component({
  selector: 'kt-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent implements OnInit {
  // Public proprties
  loaderLogo: string;
  loaderType: string;
  loaderMessage: string;
  urlLogo: string;
  logoLoaded: boolean = false;

  @ViewChild('splashScreen', { static: true }) splashScreen: ElementRef;

  /**
   * Component constructor
   *
   * @param el: ElementRef
   * @param layoutConfigService: LayoutConfigService
   * @param splashScreenService: SplachScreenService
   */
  constructor(
    private el: ElementRef,
    private layoutConfigService: LayoutConfigService,
    private splashScreenService: SplashScreenService,
    private system: SystemSettingService,
    private storeSystem: SystemSettingStore
  ) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit() {
    // init splash screen, see loader option in layout.config.ts
    const loaderConfig = this.layoutConfigService.getConfig('loader');
    this.loaderLogo = objectPath.get(loaderConfig, 'logo');
    this.loaderType = objectPath.get(loaderConfig, 'type');
    this.loaderMessage = objectPath.get(loaderConfig, 'message');

    //console.log(this.loaderLogo);
    this.splashScreenService.init(this.splashScreen);

    this.getLogo();
    this.subscribeToLogoUpdates();
  }

  getLogo() {
    this.system
      .apiSystemSettingGet('type==HEADER-ICONS')
      // .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.success && res.data.collection && res.data.collection.length > 0) {
            const children = res.data.collection[0].children;
            if (children && children.length > 0) {
              const logo = children.find(
                (item) => item.value && item.value !== '' && item.is_hidden === false
              );

              if (logo && logo.value) {
                this.urlLogo = environment.backendhost + logo.value + '?cb=' + Date.now();
                this.logoLoaded = true;
                console.log('Logo loaded from API:', this.urlLogo);
              }
            }
          }
        },
        error: (err) => {
          console.error('Error loading logo:', err);
        },
      });
  }
  subscribeToLogoUpdates() {
    this.storeSystem.settings$.subscribe({
      next: (settings) => {
        if (settings && settings.logos && settings.logos.length > 0) {
          const activeLogo = settings.logos.find(
            (item) => item.value && item.value !== '' && item.is_hidden === false
          );

          if (activeLogo && activeLogo.value) {
            const baseUrl = activeLogo.value.startsWith('http')
              ? activeLogo.value
              : environment.backendhost + activeLogo.value;
            this.urlLogo = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'cb=' + Date.now();
            this.logoLoaded = true;
          }
        }
      },
      error: (err) => {
        console.error('Error subscribing to settings:', err);
      },
    });
  }
}
